import SeoPageLayout from "@/components/SeoPageLayout";

const WystepKabaretowyTorun = () => (
  <SeoPageLayout title="Występ kabaretowy Toruń - humor w mieście Kopernika">
    <p>
      Toruń, miasto wpisane na listę UNESCO, to doskonałe miejsce na prestiżowe wydarzenia firmowe. Występ kabaretowy w Toruniu dodaje elegancji i humoru każdemu eventowi organizowanemu w tym historycznym mieście.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na eventy w Toruniu</h2>
    <p>
      Występujemy w najpiękniejszych lokalizacjach Torunia - od gotyckich sal w Starym Mieście, przez nowoczesne centra konferencyjne, po eleganckie hotele nad Wisłą. Każdy występ dostosowujemy do atmosfery miejsca i charakteru wydarzenia.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Wyjątkowe lokalizacje w Toruniu</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Sale w Starym Mieście - gotycki klimat na wyjątkowe gale</li>
      <li>Hotele nad Wisłą - eleganckie bankiety i konferencje</li>
      <li>Centra konferencyjne - profesjonalne eventy korporacyjne</li>
      <li>Restauracje w kamienicach - kameralne spotkania firmowe</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Profesjonalizm na miarę miasta UNESCO</h2>
    <p>
      Toruń to miasto, które ceni tradycję i jakość. Nasze występy kabaretowe odpowiadają na te oczekiwania - profesjonalny program, dopracowany materiał i elegancka forma gwarantują rozrywkę na najwyższym poziomie.
    </p>
  </SeoPageLayout>
);

export default WystepKabaretowyTorun;
